var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d94635",
    points: "117.873 9.355 121.752 11.476 117.873 13.597 115.751 17.476 113.629 13.597 109.749 11.476 113.629 9.355 115.751 5.476"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a7bbf",
    d: "M121.739,114.4H4c-1.104,0-2-0.896-2-2s0.896-2,2-2h117.739c1.104,0,2,0.896,2,2 S122.843,114.4,121.739,114.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a7bbf",
    d: "M59.891,114.35c-29.881,0-54.192-24.527-54.192-54.675S30.009,5,59.891,5 c23.914,0,44.723,15.473,51.781,38.502c0.324,1.056-0.27,2.175-1.326,2.498c-1.061,0.321-2.175-0.271-2.498-1.326 C101.307,23.336,82.035,9,59.891,9C32.215,9,9.699,31.732,9.699,59.675s22.516,50.675,50.192,50.675 s50.191-22.732,50.191-50.675c0-1.104,0.896-2,2-2s2,0.896,2,2C114.082,89.822,89.772,114.35,59.891,114.35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a7bbf",
    d: "M111.189 46.962c-.205 0-.412-.031-.612-.096l-16.069-5.163c-1.052-.338-1.63-1.465-1.292-2.516.338-1.053 1.462-1.631 2.516-1.293l13.457 4.324V27.815c0-1.104.896-2 2-2s2 .896 2 2v17.146c0 .639-.305 1.239-.822 1.616C112.021 46.831 111.607 46.962 111.189 46.962zM109.751 123c-.66 0-1.306-.326-1.688-.924-.595-.931-.322-2.167.609-2.762l11.966-7.641-10.943-9.274c-.843-.714-.947-1.976-.233-2.818s1.975-.948 2.819-.232l13.011 11.026c.484.41.745 1.026.703 1.66-.043.634-.384 1.209-.919 1.551l-14.251 9.1C110.492 122.898 110.119 123 109.751 123z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#68dbaf",
    d: "M45.135,44.96l-7.84-7.913c-5.864,5.919-9.491,14.095-9.491,23.127h11.088 C38.891,54.233,41.277,48.854,45.135,44.96z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9c7a",
    d: "M60.209,38.659V27.468c-8.949,0-17.05,3.661-22.914,9.579l7.84,7.913 C48.993,41.067,54.322,38.659,60.209,38.659z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#87bee7",
    d: "M60.209,27.468v11.191c11.774,0,21.318,9.633,21.318,21.515s-9.545,21.515-21.318,21.515V92.88 c17.897,0,32.406-14.643,32.406-32.706S78.107,27.468,60.209,27.468z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bdfff",
    d: "M45.135,75.388l-7.84,7.913c5.864,5.919,13.966,9.579,22.914,9.579V81.689 C54.322,81.689,48.993,79.281,45.135,75.388z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1072b5",
    d: "M38.891,60.174H27.803c0,9.031,3.627,17.208,9.491,23.126l7.84-7.913 C41.277,71.494,38.891,66.115,38.891,60.174z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgile);
export default __webpack_public_path__ + "static/media/agile.fc4abfb9d2b3f7a7e39dbe9f2d9dd8cd.svg";
export { ForwardRef as ReactComponent };